var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHeaderNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7197 9.53033C10.4268 9.23744 10.4268 8.76256 10.7197 8.46967L13.4393 5.75H1.25C0.835786 5.75 0.5 5.41421 0.5 5C0.5 4.58579 0.835786 4.25 1.25 4.25H13.4393L10.7197 1.53033C10.4268 1.23744 10.4268 0.762563 10.7197 0.46967C11.0126 0.176777 11.4874 0.176777 11.7803 0.46967L15.7803 4.46967C16.0732 4.76256 16.0732 5.23744 15.7803 5.53033L11.7803 9.53033C11.4874 9.82322 11.0126 9.82322 10.7197 9.53033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHeaderNews);
export default __webpack_public_path__ + "static/media/ArrowHeaderNews.30879b2198751ef8c2eee6736c302592.svg";
export { ForwardRef as ReactComponent };